import { Injectable } from '@angular/core';
@Injectable()
export class LimitsConstant {
    editSubtitle: string = "<br><p><i>If you modify the published limt then it would change state of the limit to un-published and de-list from Guest user page. <br>Please notify to Product Management to review and re-publish it.</i></p>";
    delMessage: string = '<p><i>If you delete limit then it cannot be restored.The deletions will reflect immediately in customer view.<br/> Are you sure, Do you want to delete the limit?<i></p>';
    statusID: number = 3;
    categoryDelMsg: string = '<p><i>This operation will delete the Category/Sub Category and cannot be restored.<br/> Do you want to continue ?<i></p>';
    categoryDelWarningMsg: string = '<p><i>Deletion of this Category/Sub Category is not allowed since it has maximums in it.<br/>Please delete all the maximums under this Category/Sub Category and retry<i></p>';
    deleteCategoryBtnID: string = "deleteCategory";
    deleteMaximumBtnID: string = "deleteBtn";
    editNote: string = "Note - This category/sub-category name will be updated in all release where it is used.";
    HTTP_STATUS_CONFLICT: number = 409;
    WarningMsg_IfSubcategoryExists: string = '<p><i>Deletion of this Category is not allowed since it has Sub Category(s) in it.<br/>Please delete all the Sub Category(s) under this Category and retry<i></p>';
    addMaximumTitle:string = "Add Limit";
    editMaximumTitle:string = "Edit Limit";
    saveLabel:string ="Save";
    maximumTitle :string = "Limit for ";
    updateStatus:string = "Update";
    newStatus:string = "New";
    maximType:string = "type";
    addString:string = "Add";
    pendingStatus:string = "Pending";
    teamMember:string = "Team_Member";
    assgin:string = "Assign";
    configAlertLabel:string = "Configuration for ";
    updateAlertFailureLabel:string = " - changes could not be updated";
    duplicateAlertFailureLabel:string = " -  Configuration already exists";
    noChnagesAlertLabel:string = " - No changes made";
    authorNotAssignedAlertLabel:string = "Author Not assigned to attribute to comment";
    commentsUpdateAlertFailureLabel:string = "Comments were not submitted";
    editConfigMaxSetAlertLabel:string = " - Create ConfigMaxSet to Edit";
    configTitle:string =" Configuration list";
    deleteConfigAlertLabel:string = " Configurations are selected for Delete";
    approveConfigAlertLabel:string =" Configurations are selected for Approve";
    alreadyApprovedConfigAlertLabel:string = "Configuration already approved by this user";
    deleteSelectLabel:string = " is selected for Delete";
    noSucessLabel:string = " - not  Succesful";
    notInApproverListLabel:string = " - User is not in the approvers list";
    configDeleteSucessAlertLabel:string = "Configuration deleted Successfully";
    configDeleteFailureAlertLabel:string = "Configuration could not be deleted";
    editConfigLabel:string = "Edit Limit";
    selectHeaderLabel:string = "Select Header";
    configMaxSetUpdateSuccessAlertLabel:string = " - ConfigMaxSet updated Succesfully";
    configMaxSetUpdateFailureAlertLabel:string = " - ConfigMaxSet could not be updated.";
    revertAlertLabel:string = " - changes reverted successfully";
    noConfigsFoundLabel:string = "No Maximums found for the selected categories";
    userNotAssignedtoApproverList:string = "Currrent user not assigned to any attributes to approve";
    configApproveFailureAlertLabel:string = "Configuration could not be approved";


}  


// WEBPACK FOOTER //
// ./src/app/limits/limitsconstant.ts